/**
 * “See more” / “See less” for text cut down to its first paragraph by
 * wgi_the_read_more().
 */
( function() {
	const toggles = document.querySelectorAll( '.read-more > .toggle[aria-controls]' );

	/**
	 * Show or hide the rest of the text and relabel the toggle.
	 *
	 * @param {HTMLButtonElement} toggle The toggle button.
	 * @param {HTMLElement}       more   The hidden part of the text.
	 * @param {boolean}           open   Whether to show it.
	 */
	function set( toggle, more, open ) {
		if ( open ) {
			more.removeAttribute( 'hidden' );
		} else {
			more.setAttribute( 'hidden', 'until-found' );
		}

		toggle.setAttribute( 'aria-expanded', String( open ) );
		toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
	}

	toggles.forEach( function( toggle ) {
		const more = document.getElementById( toggle.getAttribute( 'aria-controls' ) );

		if ( ! more ) {
			return;
		}

		toggle.addEventListener( 'click', function() {
			const open = 'true' !== toggle.getAttribute( 'aria-expanded' );

			set( toggle, more, open );

			// Closing pulls the toggle up; keep it under the reader's eye.
			if ( ! open ) {
				toggle.scrollIntoView( { block: 'nearest' } );
			}
		} );

		// Find in page reveals `hidden="until-found"` on its own.
		more.addEventListener( 'beforematch', function() {
			set( toggle, more, true );
		} );
	} );
}() );
